import { render, staticRenderFns } from "./ManageOrder.vue?vue&type=template&id=5df7fdd0&scoped=true"
import script from "./ManageOrder.vue?vue&type=script&lang=js"
export * from "./ManageOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df7fdd0",
  null
  
)

export default component.exports